import React, { Component } from 'react';
import { debounce } from 'lodash';

import Events from 'client/components/events';
import Filters from 'client/components/filters';
import {
    FilterQueryParams,
    getFilters,
    getFiltersFromQuery,
} from 'client/components/filters/filters-query';
import { Homepage } from 'client/types/homepage';
import { List } from 'client/types/common';
import { Event } from 'client/types/event';
import { ApiFilters } from 'client/types/filters';

export interface DispatchProps {
    fetchHomepage(params?: { external?: boolean, speakerId?: string }): any;
    fetchEvents(params?: { filters: ApiFilters, pageNumber?: number, speakerId?: string, external?: boolean }): any;
}

export interface StateProps {
    data: Homepage;
    isLoading: boolean;
    isEventsLoading: boolean;
    events: List<Event>;
}

type Props = StateProps & DispatchProps & {
    q: string;
    onChangeUrlQueryParams: (params: object) => void;
};

interface OwnState {
    initiated: boolean;
    pageNumber: number;
    filters?: ApiFilters;
}

class HomeContent extends Component<Props, OwnState> {
    static getDerivedStateFromProps(nextProps: Props, prevState: OwnState) {
        const { filters } = getFiltersFromQuery(nextProps.q);

        if (prevState.initiated) {
            return null;
        }

        return {
            filters,
            pageNumber: 1,
            initiated: true,
        };
    }

    state: OwnState = {
        initiated: false,
        pageNumber: 1,
    };

    componentDidMount() {
        const { fetchHomepage, fetchEvents, data: { filters }, q } = this.props;

        if (!Object.keys(filters).length) {
            fetchHomepage();
            fetchEvents({ filters: getFiltersFromQuery(q) });
        }
    }

    render() {
        const {
            isLoading,
            isEventsLoading,
            data: { filters },
            events,
            q,
        } = this.props;

        const filtersProps = getFiltersFromQuery(q);

        return (
            <>
                <Filters
                    data={filters}
                    isLoading={isLoading}
                    onChangeFilters={debounce(this.onChangeFilters, 200)}
                    {...filtersProps}
                />
                <Events
                    data={events}
                    isLoading={isEventsLoading}
                    onClickToShowMore={this.onClickToShowMore}
                />
            </>
        );
    }

    onLoadEvents = () => {
        const { fetchEvents, q } = this.props;
        const { pageNumber, filters = {} } = this.state;
        const { speakerId } = getFiltersFromQuery(q);

        fetchEvents({ filters, pageNumber, speakerId });
    };

    onClickToShowMore = () => {
        this.setState({ pageNumber: this.state.pageNumber + 1 }, this.onLoadEvents);
    };

    onChangeFilters = (params: FilterQueryParams) => {
        const filters = getFilters(params);

        this.props.onChangeUrlQueryParams({ q: JSON.stringify(params) });

        this.setState({ filters, pageNumber: 1 }, () => {
            this.onLoadEvents();
        });
    };
}

export default HomeContent;
